
import * as audioTools from "./AudioTools.js";

export class CompPlayer {
	constructor(showMsgCb)
	{
      	this.bufferSource = null;
      	this.playingComp = null;
      	this.audioCtx = audioTools.getAudioContext();
      	this.showMsg = showMsgCb;
	}

	togglePlayComp(comp)
	{
		const self = this;
		if(self.bufferSource != null)
		{
			const playNew = self.playingComp == null || self.playingComp.file_name != comp.file_name;
			self.stopAndTearDownPlayingBuffer();
			if(!playNew)
			{
				return;
			}
			//Stop and tear down buffer
		}

		const audioFailed = () => {
        	self.showMsg("Audio Failed to load for comp: '" + comp.name + "'' with file_name: '" + comp.file_name + "'");
	    }

	    const audioLoaded = (buffer) => {
	        self.bufferSource = self.audioCtx.createBufferSource();
	        self.bufferSource.buffer = buffer;
	        self.bufferSource.connect(self.audioCtx.destination); // connect the source to the context's destination (the speakers)
	        self.bufferSource.onEnded = self.tearDownPlayingBuffer;
	        self.bufferSource.start();
	        self.playingComp = comp;	
	    }

	    //console.log("Trying to load: ", this.props.data.file_name);
	      
	    audioTools.loadAudioFile(globalMediaPath + comp.file_name, 
	    	self.audioCtx, audioLoaded, audioFailed, null);
	}

	stopAndTearDownPlayingBuffer()
	{
		this.bufferSource.stop();
		this.tearDownPlayingBuffer();
	}

	tearDownPlayingBuffer()
	{
		this.bufferSource = null;
		this.playingComp = null; 
	}

	tearDown()
	{
		if(this.bufferSource != null)
		{
			this.stopAndTearDownPlayingBuffer();
		}

		//this.audioCtx.close();
	}

}


// WEBPACK FOOTER //
// ./js/genericCompPlayer.js